const Typing: React.FC = () => (
  <div className='w-20 h-8 relative px-2.5 ml-1 bg-[#E6ECF1] rounded-[20px] flex items-center'>
    <span className='w-2 h-2 mx-1 bg-gray-500 rounded-full opacity-0 animate-loadingFade [animation-delay:0s]' />
    <span className='w-2 h-2 mx-1 bg-gray-500 rounded-full opacity-0 animate-loadingFade [animation-delay:0.2s]' />
    <span className='w-2 h-2 mx-1 bg-gray-500 rounded-full opacity-0 animate-loadingFade [animation-delay:0.4s]' />
  </div>
)

export default Typing
